export default __webpack_public_path__ + "static/media/google_play-store.4376bf9e.svg";